import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { api } from '../../api';
import Swal from 'sweetalert2';

const ConsultationForm = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Select Your Industry');
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        industry: ''
    });
    const [errors, setErrors] = useState({});

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setFormData({ ...formData, industry: option });
        setIsOpen(false);
    };

    const options = [
        'Solopreneurs', 'Personal Training', 'Beauty Spa', 'Bakery & Spa',
        'Bakery & Cafe', 'Consultancy', 'Coaching Center', 'Boutique Services',
        'Clinics & Medicals', 'Other Services',
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

   const validateEthiopianPhoneNumber = (phone) => {
    // Allow only mobile numbers starting with +2519, +2517, 09, or 07
    const cleanedPhone = phone.replace(/[^\d+]/g, '');
    const pattern = /^(?:\+251|0)(9|7)\d{8}$/;
    return pattern.test(cleanedPhone);
};


    const formatPhoneNumber = (phone) => {
        // Format to standard +251 format
        let cleaned = phone.replace(/[^\d+]/g, '');
        
        // Convert 0 to +251
        if (cleaned.startsWith('0')) {
            cleaned = '+251' + cleaned.substring(1);
        }
        // Ensure +251 is used
        else if (cleaned.startsWith('251')) {
            cleaned = '+' + cleaned;
        }
        
        return cleaned;
    };

    const validateForm = () => {
        const newErrors = {};
        
        // Validate Name
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        
        // Validate Phone
        if (!formData.phone.trim()) {
            newErrors.phone = 'Phone number is required';
        } else if (!validateEthiopianPhoneNumber(formData.phone)) {
            newErrors.phone = 'Please enter a valid Ethiopian phone number';
        }

        // Validate Email
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!emailPattern.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        // Validate Industry
        if (!formData.industry || formData.industry === 'Select Your Industry') 
            newErrors.industry = 'Please select your industry';
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            // Format phone number before submission
            const formattedData = {
                ...formData,
                phone: formatPhoneNumber(formData.phone)
            };

            const response = await api.post('/consultations', formattedData);

            Swal.fire({
                title: 'Thanks for Reaching Out!',
                text: 'We\'ve received your consultation request. Our team will be in touch shortly to spark something amazing together.',
                icon: 'success',
                confirmButtonText: 'Great!',
                confirmButtonColor: '#FD5F20',
            });

            setFormData({ name: '', phone: '', email: '', industry: '' });
            setSelectedOption('Select Your Industry');
        } catch (error) {
            Swal.fire({
                title: 'Oops!',
                text: error.response?.data?.message || 'Something went wrong while submitting your request. Please try again shortly.',
                icon: 'error',
                confirmButtonText: 'Okay',
                confirmButtonColor: '#FD5F20',
            });
        }
    };

    return (
        <div className="max-w-lg mx-auto  p-6 rounded-lg ">
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Full Name"
                            className={`w-full border-2 p-2 rounded-md focus:ring-2 ${
                                errors.name ? 'border-red-500' : 'border-[#FD5F20]'
                            }`}
                        />
                        {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                    </div>
                    <div>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Phone (e.g., +251911223344 or 0911223344)"
                            className={`w-full border-2 p-2 rounded-md focus:ring-2 ${
                                errors.phone ? 'border-red-500' : 'border-[#FD5F20]'
                            }`}
                        />
                        {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
                        
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email Address"
                            className={`w-full border-2 p-2 rounded-md focus:ring-2 ${
                                errors.email ? 'border-red-500' : 'border-[#FD5F20]'
                            }`}
                        />
                        {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                    </div>
                    <div className="relative">
                        <div
                            onClick={toggleDropdown}
                            className={`w-full border-2 p-2 rounded-md cursor-pointer flex justify-between items-center ${
                                errors.industry ? 'border-red-500' : 'border-[#FD5F20]'
                            }`}
                        >
                            {selectedOption}
                            <FontAwesomeIcon icon={faChevronDown} className='text-[#FD5F20]' />
                        </div>
                        {isOpen && (
                            <ul className="absolute left-0 w-full mt-1  border border-[#FD5F20] rounded-md  z-50 max-h-60 overflow-y-auto">
                                {options.map((option) => (
                                    <li
                                        key={option}
                                        className="px-4 py-2 cursor-pointer hover:bg-gray-200"
                                        onClick={() => handleOptionClick(option)}
                                    >
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        )}
                        {errors.industry && <p className="text-red-500 text-sm">{errors.industry}</p>}
                    </div>
                </div>

                <button
                    type="submit"
                    className="w-full bg-[#FD5F20] text-white p-3 rounded-md font-bold hover:bg-opacity-90 transition"
                >
                    Get Free Consultation
                </button>
            </form>
        </div>
    );
};

export default ConsultationForm;